import React from 'react';
import { StackedColumn } from '../../../../../core';
import {
  DateTimeFilter,
  ProviderDetails,
  ProviderSummary,
  SlotDateGroup,
} from '../../../../../api/models';
import { SimilarProvider } from './similarProvider';
import { NoSimilarProviders } from './noSimilarProviders';

export interface SimilarProvidersProps {
  alternateProviders: ProviderSummary[];
  filter: DateTimeFilter;
  onCareProviderSelected: (
    newProviderDetails: ProviderDetails,
    availableAppointmentSlots?: SlotDateGroup[]
  ) => void;
}

const SimilarProviders: React.FC<SimilarProvidersProps> = (
  props: SimilarProvidersProps
) => {
  return (
    <StackedColumn fillHeight={true}>
      {props.alternateProviders && props.alternateProviders.length > 0 ? (
        props.alternateProviders.map((providerSummary) => (
          <SimilarProvider
            key={providerSummary.provider?.id}
            providerSummary={providerSummary}
            onCareProviderSelected={props.onCareProviderSelected}
          />
        ))
      ) : (
        <NoSimilarProviders filter={props.filter} />
      )}
    </StackedColumn>
  );
};

export default SimilarProviders;
